import {
  GET_REPORT_TRANSACTION_PENDING,
  GET_REPORT_TRANSACTION_SUCCESS,
  GET_REPORT_TRANSACTION_ERROR,
  EXPORT_REPORT_TRANSACTION_PENDING,
  EXPORT_REPORT_TRANSACTION_SUCCESS,
  EXPORT_REPORT_TRANSACTION_ERROR,
  REPORT_TRANSACTION_DATA,
  SET_REPORT_TRANSACTION_MODAL,
} from "../../../actions/report/transaction";

const initialState = {
  pending: false,
  error: null,
  data: null,
  detailData: null,
  isOpenModal: false,
  modalType: "",
};

const transaction = (state = initialState, action) => {
  switch (action.type) {
    case GET_REPORT_TRANSACTION_PENDING:
      return {
        ...state,
        pending: true,
      };
    case GET_REPORT_TRANSACTION_SUCCESS:
      return {
        ...state,
        pending: false,
        data: action.data,
      };
    case GET_REPORT_TRANSACTION_ERROR:
      return {
        ...state,
        pending: false,
        error: action.error,
      };
    case EXPORT_REPORT_TRANSACTION_PENDING:
      return {
        ...state,
        pending: true,
      };
    case EXPORT_REPORT_TRANSACTION_SUCCESS:
      return {
        ...state,
        pending: false,
        data: action.data,
      };
    case EXPORT_REPORT_TRANSACTION_ERROR:
      return {
        ...state,
        pending: false,
        error: action.error,
      };
    case REPORT_TRANSACTION_DATA:
      return {
        ...state,
        detailData: action.data,
      };
    case SET_REPORT_TRANSACTION_MODAL:
      return {
        ...state,
        isOpenModal: action.data.isOpen,
        modalType: action.data.modalType,
      };
    default:
      return state;
  }
};

export default transaction;
